import { NgModule } from '@angular/core';

import { CitySelectorModule } from '../city-selector';
import { CityPairSelectorComponent } from './city-pair-selector.component';

const MODULES = [CitySelectorModule];
const DECLARATIONS = [CityPairSelectorComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class CityPairSelectorModule {}
